import React from 'react';
import { BrowseFeedItemLocation } from './location/BrowseFeedItemLocation';
import { LocationCard } from '../../../location/card/LocationCard';
import { Outlet } from '../../../../XV2';
import { Location } from '../../../../XV2';

type ItemTypeBrowseFeedItemLocation = {
    id: number;
    type: 'LOCATION';
    location: Location;
};

type ItemTypeBrowseFeedItemOutletGroup = {
    id: number;
    type: 'OUTLET_GROUP';
    outlets: Outlet[];
    data: {
        image: string;
        name: string;
    };
};

type ItemTypeBrowseFeedItemLegacy = {
    id: string;
    name: string;
    image: string;
    url: string;
    type: 'LEGACY';
};

interface Props {
    item: ItemTypeBrowseFeedItemLocation | ItemTypeBrowseFeedItemOutletGroup | ItemTypeBrowseFeedItemLegacy;
}

export function BrowseFeedItem({ item }: Props) {
    if (item.type === 'LOCATION') {
        const { location } = item as ItemTypeBrowseFeedItemLocation;
        return <BrowseFeedItemLocation feedItemId={item.id} location={location} />;
    }

    if (item.type === 'LEGACY') {
        const { name, image, url } = item as ItemTypeBrowseFeedItemLegacy;
        return <LocationCard to={`${url}?redirect=${window.location.href}`} name={name} image={image} />;
    }

    return null;
}
